import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren, useContext } from 'react'
import styled from 'styled-components'
import { Icon } from '../../icon/icon'
import { MobileMenuContext } from '../MobileMenuContext'
import { StyledListItem, StyledListItemGrid, StyledMenuItemText } from './styledMobileMenuItem'

export type MobileMenuNavigationItemProps = React.ComponentProps<typeof StyledListItem> & {
  level?: number
  idx?: number
  name?: string
  hasChildren?: boolean
}

export const StyledCheveronRight = styled(Icon)`
  position: absolute;
  top: 40%;
  right: 20px;
  color: ${props => props.theme.palette.primary.main};
  font-size: ${props => props.theme.typography.pxToRem(14)};
  margin-right: ${props => props.theme.typography.pxToRem(8)};
`

export const MobileMenuNavigationItem: React.FC<PropsWithChildren<MobileMenuNavigationItemProps>> = ({ name, level, hasChildren, idx, children, ...props }) => {
  const menuContext = useContext(MobileMenuContext)
  const onClick = (event) => {
    event.stopPropagation()
    menuContext.setMenuOpen(level ?? 0, (idx ?? 0) + 1)
  }

  return (
    <StyledListItem $isLink={true} $secondary={Boolean(level && level > 0)} onClick={onClick} { ...props }>
      <StyledListItemGrid container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <Grid item xs={11}>
          <Grid container direction={'row'} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item xs={12}>
              <StyledMenuItemText>{ name }</StyledMenuItemText>
            </Grid>
          </Grid>
        </Grid>
        {hasChildren && (
          <StyledCheveronRight icon={faChevronRight} />
        )}
        { children }
      </StyledListItemGrid>
    </StyledListItem>
  )
}
